import { isEmpty } from 'lodash';
import { useEffect } from 'react';

import { RtkPluginMain } from '@cloudflare/realtimekit-react-ui';
import useMeeting from 'hooks/useMeeting';
import { useAppSelector } from 'hooks/store';
import { useResponsiveLayout } from 'hooks/useResponsiveLayout';
import { selectWhiteBoardStatus } from 'store/slice/pluginStatus.slice';

const Plugins = () => {
  const { meeting, activePlugins, whiteBoardPlugin, tutors } = useMeeting();
  const selectedWhiteBoardStatus = useAppSelector(selectWhiteBoardStatus);
  // Same zoom caveat as the slide iframe: vh inside the zoomed root is scaled again.
  const { zoom } = useResponsiveLayout();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mtg = meeting as any;
    if (
      activePlugins.length > 0 &&
      (mtg?.meta?.selfActiveTab?.id === 'null' || !mtg?.meta?.selfActiveTab?.id)
    ) {
      mtg?.meta?.setSelfActiveTab(
        {
          type: 'plugin',
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          id: (activePlugins[0] as any).id,
        },
        0,
      );
    }
  }, [activePlugins, meeting]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const plugin = whiteBoardPlugin as any;
    plugin?.on('ready', () => {
      if (isEmpty(tutors)) return;
      plugin?.sendData({
        eventName: 'config',
        data: {
          eventName: 'config',
          follow: tutors?.[0]?.id,
          autoScale: true,
        },
      });
    });
    return () => {
      plugin?.removeAllListeners('ready');
    };
  }, [whiteBoardPlugin, tutors]);

  return (
    <>
      {activePlugins?.map((plugin) => {
        return (
          <div
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key={(plugin as any).id}
            style={{
              transition: 'opacity 0.3s ease',
              ...(selectedWhiteBoardStatus?.show ? { height: `${90 / zoom}vh` } : null),
            }}
            className={`${selectedWhiteBoardStatus?.show ? 'p-2' : 'h-[0vh] opacity-0'}`}
          >
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            <RtkPluginMain meeting={meeting as any} plugin={plugin as any} />
          </div>
        );
      })}
    </>
  );
};

export default Plugins;
